var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconPlayLightGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.0625C4.39277 1.0625 1.0625 4.39277 1.0625 8.5C1.0625 12.6072 4.39277 15.9375 8.5 15.9375C12.6072 15.9375 15.9375 12.6072 15.9375 8.5C15.9375 4.39277 12.6072 1.0625 8.5 1.0625ZM10.8923 8.61455L7.2665 11.2525C7.24663 11.2668 7.2232 11.2754 7.19879 11.2772C7.17438 11.279 7.14994 11.2741 7.12815 11.2629C7.10636 11.2518 7.08806 11.2348 7.07528 11.214C7.06249 11.1931 7.0557 11.1691 7.05566 11.1446V5.87197C7.05558 5.84745 7.0623 5.82338 7.07506 5.80243C7.08782 5.78149 7.10613 5.76448 7.12797 5.75331C7.1498 5.74214 7.1743 5.73723 7.19875 5.73912C7.22321 5.74102 7.24666 5.74965 7.2665 5.76406L10.8923 8.40039C10.9094 8.4125 10.9234 8.42855 10.933 8.44718C10.9427 8.46582 10.9477 8.48649 10.9477 8.50747C10.9477 8.52845 10.9427 8.54912 10.933 8.56776C10.9234 8.58639 10.9094 8.60244 10.8923 8.61455Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconPlayLightGray);
export default __webpack_public_path__ + "static/media/TH-Icon-Play-LightGray.316134ada009f0e6d18b57e870733914.svg";
export { ForwardRef as ReactComponent };